const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  saveUrl ({ rootState }, params) {
    return rootState.axios.post('/tpsp/v1frontend/tptt-can-mail/save-url', params)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
